<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <!--<div class="logo">-->
      <!--<a class="simple-text logo-mini"-->
         <!--href="https://www.creative-tim.com/product/vue-paper-dashboard-2-pro">-->
          <!--<div class="logo-img">-->
              <!--<img :src="logo" alt="">-->
          <!--</div>-->
      <!--</a>-->
      <!--<a class="simple-text logo-normal"-->
         <!--href="https://www.creative-tim.com/vue-paper-dashboard-2-pro">-->
          <!--{{ title }}-->
      <!--</a>-->
    <!--</div>-->
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in expoStatSidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'

  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    computed: {
      ...mapState({
        userInfo: state => state.user,
        currentEventInfo: state => state.events.currentEventInfo,
        // available: state => state.events.available
      }),
      // ...mapGetters({currentEventInfo: 'events/currentEventInfo'}),
      expoStatSidebarLinks () {
        let links = [
          // {
          //   icon: "nc-icon nc-chart-bar-32",
          //   name: this.$gettext("Statistics"),
          //   path: "/statistics"
          // }
        ]
        // Если указано мероприятие, отображаем стенды
        if (this.currentEventInfo && this.currentEventInfo.uri) {
          // debugger
          links.push({
              icon: "es-icon es-icon-tripod",
              name: this.$gettext("Stands"),
              path: {name: 'stands-index', params: {eventUri: this.currentEventInfo.uri}},
            })
        }

        // Если суперпользователь, отображаем раздел администрирования
        if (this.userInfo && this.userInfo.isSuperuser) {
          // Добавляем раздел с настройками

          links.push({
            icon: "nc-icon nc-ruler-pencil",
            name: this.$gettext("Manage"),
            path: "/manage",
            children: [
              {
                name: this.$gettext("Brands"),
                path: {name: 'brands-index'},
                icon: 'es-icon es-icon-stamp'
              },
              {
                name: this.$gettext("Events"),
                path: {name: 'events-index'},
                icon: 'es-icon es-icon-calendar-event'
              },
              {
                name: this.$gettext("Servers"),
                path: {name: 'manage-servers'},
                icon: 'es-icon es-icon-server-rack'
              },
              {
                name: this.$gettext("Databases"),
                path: {name: 'manage-databases'},
                icon: 'es-icon es-icon-database'
              },
              {
                name: this.$gettext("Surveys"),
                path: {name: 'manage-surveys'},
                icon: 'es-icon es-icon-questionnaire'
              },
              {
                name: this.$gettext("Schema editor"),
                path: {name: 'admin-self-registration'}
              },

            ]
          })
        }
        return links
      }
    },
    props: {
      title: {
        type: String,
        default: 'Vue PDP Pro',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: 'static/img/vue-logo.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
